import axios from "../utils/axios";

// ==========================================
// Admin Customers
// ==========================================

export const getCustomers = async (params) => {
    const response = await axios.get("/admin/customers", { params });
    return response.data;
};

export const getCustomerById = async (id) => {
    const response = await axios.get(`/admin/customers/${id}`);
    return response.data;
};

export const getCustomerOrders = async (id, params) => {
    const response = await axios.get(`/admin/customers/${id}/orders`, { params });
    return response.data;
};

export const getCustomerAddresses = async (id) => {
    const response = await axios.get(`/admin/customers/${id}/addresses`);
    return response.data;
};

export const getCustomerWishlist = async (id) => {
    const response = await axios.get(`/admin/customers/${id}/wishlist`);
    return response.data;
};

export const updateCustomerStatus = async (id, data) => {
    const response = await axios.patch(`/admin/customers/${id}/status`, data);
    return response.data;
};

export const deleteCustomer = async (id) => {
    const response = await axios.delete(`/admin/customers/${id}`);
    return response.data;
};
